import React from 'react';
import {placeholderMediumTextStyles} from "../Style";
import {detectSource} from "../utils/sourceDetection";
import {useFeature} from "../hooks/useFeature";

const NavigateCarInsurance = ({steps}) => {
    const classNames = (...classes) => classes.filter(Boolean).join(' ');
    const source = detectSource();
    const useRepairInsuranceName = useFeature('RepairInsuranceFeatureToggle', source);
    const primaryColor = source === 'VTNZ' ? '#E87722' : '#1851a3';
  const secondaryColor = source === 'VTNZ' ? '#f5e5da' : '#EFF6FF';
    return (
      <div className="lg-navigation-width" style={{paddingBottom: "40px"}}>
            <nav style={{paddingRight: '0', paddingLeft: '0'}} aria-label="Progress">
          {/* Horizontal divider with title */}
          <div style={{
              display: 'flex',
              alignItems: 'center',
              marginTop: window.innerWidth <= 768 ? '5px' : '9px',
              marginBottom: window.innerWidth <= 768 ? '5px' : '9px',
              minHeight: window.innerWidth <= 768 ? '32px' : '28px',
              padding: window.innerWidth <= 768 ? '0 2.8%' : '0 9%'
            }}>
              <div style={{flex: 1, height: '1px', borderTop: `1px solid ${primaryColor}`}}/>
              <span style={{
                color: primaryColor,
                fontWeight: '700',
                fontSize: window.innerWidth <= 768 ? '14px' : '16px',
                padding: '0 12px',
                whiteSpace: 'nowrap'
              }}>
                {useRepairInsuranceName ? 'Repair Insurance' : 'Mechanical Breakdown Insurance'}
              </span>
              <div style={{flex: 1, height: '1px', borderTop: `1px solid ${primaryColor}`}}/>
            </div>
                <ol role="list"
                    style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(4, 1fr)',
                        paddingLeft: '0',
                        position: 'relative',
                        gap: '8px',
                        margin: '0 auto',
                        maxWidth: '100%'
                    }}>
                    {steps.map((step, index) => (
                        <li key={index}
                            style={{
                                listStyle: 'none',
                                margin: '0 3px',
                                position: 'relative',
                                textAlign: 'center',
                                minHeight: '80px', // Add minimum height for mobile
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center'
                            }}>
                            <div style={{
                                ...placeholderMediumTextStyles,
                                display: "flex",
                                flexDirection: 'column',
                                alignItems: 'center',
                                width: '100%',
                                position: 'relative'
                            }}>
                                {/* Description text with responsive styling */}
                                <span style={{
                                  color: primaryColor,
                                    fontWeight: '700',
                                    textAlign: "center",
                                    fontSize: window.innerWidth <= 768 ? '12px' : '14px', // Smaller font on mobile
                                    marginBottom: '8px', // Reduced space between text and icon
                                    wordBreak: 'break-word',
                                    lineHeight: '1.2',
                                    padding: '0 4px',
                                    minHeight: window.innerWidth <= 768 ? '32px' : '28px', // Ensure consistent height
                                    textTransform: source === 'VTNZ' ? 'uppercase' : 'none'
                                }}>
                                    {step.desc}
                                </span>

                                {/* Icons with adjusted positioning */}
                                <span style={{
                                    position: 'absolute',
                                    left: '50%',
                                    transform: 'translateX(-50%)',
                                    top: '45px', // Adjusted positioning for better spacing
                                    zIndex: 50,
                                    display: 'flex',
                                    justifyContent: 'center'
                                }}>
                                    {step.status === 'complete' && (
                                        <svg width="32" height="33" viewBox="0 0 32 33" fill="none"
                                             xmlns="http://www.w3.org/2000/svg">
                                          <rect y="0.775391" width="32" height="32" rx="16" fill={primaryColor}/>
                                            <path
                                                fillRule="evenodd"
                                                clipRule="evenodd"
                                                d="M22.7071 12.0683C23.0976 12.4588 23.0976 13.092 22.7071 13.4825L14.7071 21.4825C14.3166 21.873 13.6834 21.873 13.2929 21.4825L9.29289 17.4825C8.90237 17.092 8.90237 16.4588 9.29289 16.0683C9.68342 15.6778 10.3166 15.6778 10.7071 16.0683L14 19.3612L21.2929 12.0683C21.6834 11.6778 22.3166 11.6778 22.7071 12.0683Z"
                                                fill="white"
                                            />
                                        </svg>
                                    )}
                                    {step.status === 'current' && (
                                        <svg width="32" height="33" viewBox="0 0 32 33" fill="none"
                                             xmlns="http://www.w3.org/2000/svg">
                                          <rect x="1" y="1.77539" width="30" height="30" rx="15" fill={secondaryColor}/>
                                          <rect x="1" y="1.77539" width="30" height="30" rx="15" stroke={primaryColor}
                                                  strokeWidth="2"/>
                                          <circle cx="16" cy="16.7754" r="5" fill={primaryColor}/>
                                        </svg>
                                    )}
                                    {step.status === 'upcoming' && (
                                        <svg width="32" height="33" viewBox="0 0 32 33" fill="none"
                                             xmlns="http://www.w3.org/2000/svg">
                                            <rect x="1" y="1.77539" width="30" height="30" rx="15" fill="white"/>
                                            <rect x="1" y="1.77539" width="30" height="30" rx="15" stroke="#D1D5DB"
                                                  strokeWidth="2"/>
                                        </svg>
                                    )}
                                </span>

                                {/* Connecting lines with responsive positioning */}
                                {index !== steps.length - 1 && (
                                    <span style={{
                                        position: 'absolute',
                                        width: window.innerWidth <= 768 ? 'calc(100% + 6px)' : 'calc(100% - 6px)', // Responsive width
                                        left: window.innerWidth <= 768 ? '66%' : '60%', // Responsive positioning
                                        top: '61px', // Center line with circle
                                        zIndex: 40
                                    }}>
                                        <hr style={{
                                            margin: 0,
                                            border: 'none',
                                            borderTop: '1px solid #D1D5DB',
                                            width: '100%'
                                        }}/>
                                    </span>
                                )}
                            </div>
                        </li>
                    ))}
                </ol>
            </nav>
        </div>
    );
};

export default NavigateCarInsurance;
